<template>
  <div class="quota-list-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        :option="option"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
        @row-click="handleEdit"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!-- <el-button type="primary"  @click="openFilter">
                        <a-icon type="filter" /> 高级筛选
                    </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="handleAdd({ id: -1 })"
            v-if="permission.factoringQuotaSchemeList_add"
          >
            新增报价</el-button
          >
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            :disabled="disabled"
            @click.stop="handleDelete()"
            v-if="permission.factoringQuotaSchemeList_delete"
            >删除
          </el-button>

          <!-- <el-button size="small" icon="el-icon-download" @click="exportShow"
            >导出数据
          </el-button> -->
        </template>

        <template slot="name" slot-scope="{ row }">
          <div class="project-name project_name" @click="handleEdit(row)">
            {{ row.name }}
          </div>
        </template>
        <template slot="projectName" slot-scope="{ row }">
          <div
            class="project-name"
            @click="handleProjectEdit(item)"
            v-for="(item, index) in row.projectList"
            :key="index"
            style="margin-top: 5px"
          >
            <el-tag
              v-if="item.projectName"
              size="mini"
              :type="
                item.stage == 3
                  ? 'primary'
                    :item.stage == 2
                  ? 'success'
                  : item.stage == 1
                  ? 'warning'
                  : item.stage == 0
                  ? ''
                  : ''
              "
            >
              {{
                item.stage == 3
                  ? '投放管理'
                  : item.stage == 2
                  ? "合同管理"
                  : item.stage == 1
                  ? "项目尽调"
                  : item.stage == 0
                  ? "项目立项"
                  : ""
              }}
            </el-tag>
            {{ item.projectName }}
          </div>
        </template>
      </avue-crud>
    </div>

    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="60%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <div class="drawer_screen_wrapper">
        <div class="screen_header">
          <div class="screen_header_name">
            <a-icon type="filter" />
            高级筛选
          </div>
          <div class="screen_header_remarks" @click="drawer = false">
            <i class="el-icon-video-play"></i>
            收起
          </div>
        </div>
        <div class="screen_content">
          <avue-form
            :option="filterConfig"
            ref="formScreen"
            v-model="searchForm"
            @submit="filterSearch"
            @reset-change="searchResetScreen"
          >
            <template slot="factoringCredit">
              <div class="form_slot">
                <el-input-number
                  v-model="searchForm.factoringCreditMin"
                  :controls="false"
                  placeholder="开始数值"
                  style="width: 100%"
                />
                &nbsp;~&nbsp;
                <el-input-number
                  v-model="searchForm.factoringCreditMin"
                  :controls="false"
                  placeholder="结束数值"
                  style="width: 100%"
                />
              </div>
            </template>
          </avue-form>
        </div>
      </div>
    </el-drawer>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import commonList from "@/mixins/list";
import { quotaListConfig, filterConfig } from "./config.js";
import { getQuotaList, deleteQuota ,getPageFill} from "@/api/factoring/factoringScheme";
import { mapGetters } from "vuex";
export default {
  name: "quotaList",
  mixins: [commonList],
  data() {
    return {
      drawer: false,
      tableData: [],
      form: {},
      searchForm: {},
      checkUserList: [],
      checkdepartment: [],
      option: quotaListConfig(
        this.getMoney,
        this.selectPersonClick,
        this.selectDeptClick
      ),
      filterConfig: filterConfig(this.selectPersonClick, this.selectDeptClick),
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      selectionList: [],
      disabled: true,
    };
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
  },
  computed: {
    ...mapGetters(["userInfo",'permission']),
  },

  watch: {
    selectionList: {
      handler(data) {
        let list = data.filter((item) => {
          return item.projectList.length > 0;
        });

        this.disabled = list.length > 0 || data.length == 0;
      },
      deep: true,
    },
  },
  mounted() {
    let setParams = {
      departmentIDKey: "managerDept",
    };
    this.setCommonParams(setParams);
    // 设置导出链接
    this.setExportUrl("/api/bl/blquota/export");
  },
  methods: {
    cloudTages(data) {
      this.searchForm = data
    },
    
    handleAdd(row) {
      this.$router.push({
        path: `/factoring/quotaScheme/addScheme/${row.id}`,
        query: {
          beforeBjList: true,
        },
      });
    },
    handleEdit(row) {
      if(!this.permission.factoringQuotaSchemeList_view){
        this.$message.error("没有查看权限");
        return
      }
      this.$router.push({
        path: `/factoring/quotaScheme/editScheme/${row.id}`,
        query: {
          beforeBjList: true,
        },
      });
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((a) => !res.has(a) && res.set(a, 1));
    },
    async queryTableData() {
      let that = this;
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
      };
      // Array.from(new Set(arr)
      let res = await getPageFill(params);
      if (res.data.code == 200) {
        let list = res.data.data.records;

        // list = list.map((item) => {
        //   return {
        //     ...item,
        //     projectList: that.unique(
        //       item.projectList.map((el) => {
        //         return el.projectName;
        //       })
        //     ),
        //   };
        // });

        this.tableData = list;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    //搜索
    searchChange(params, done) {
      this.searchForm = params;
      this.page.currentPage = 1;
      this.queryTableData();
      done();
    },
    //清空
    searchReset() {
      if (this.cloudStatus) {
        this.cloudStatus = false;
        return;
      }
      this.searchForm = {};
      this.checkUserList = [];
      this.queryTableData();
    },
    //选择项发生变化 传入数组
    selectionChange(list) {
      this.selectionList = list;
    },
    handleDelete() {
      let self = this;
      if (this.selectionList.length > 0) {
        this.$confirm("确定删除选择的数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let ids = this.selectionList.map((item) => {
              return item.id;
            });
            let res = await deleteQuota({ ids: ids.join(",") });
            if (res.data.code == 200) {
              self.$message({
                type: "success",
                message: "删除成功",
              });
              self.queryTableData();
            }
          })
          .catch(() => {
            self.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message.error("请选择数据进行删除");
      }
    },
    save(row) {
      this.$refs.cloudtage.save(row);
    },
    handleProjectEdit(row) {
      if (row.stage == 0) {
        this.$router.push({
          path: `/factoring/buildProject/projectDetail/${row.extraId}`,
        });
      } else if (row.stage == 1) {
        this.$router.push({
          path: `/factoring/projectSurvey/surveyDetail/${row.extraId}`,
        });
      } else if (row.stage == 2) {
        this.$router.push({
          path: `/factoring/contractManage/contractDetail/${row.extraId}`,
        });
      }else if (row.stage == 3) {
        this.$router.push({
          path: `/factoring/InvestmentLoanManagement/investmentLoanDetail/${row.extraId}`,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.quota-list-container {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
  .project_name {
    color: #409eff;
  }
  .quota-status {
    position: relative;
    padding-left: 20px;
  }
  .quota-status::before {
    position: absolute;
    content: "";
    background-color: #19b16b;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    left: 12px;
    top: 7px;
  }
  .red-point::before {
    color: #f56c6c !important;
  }
}
</style>